import styled from 'styled-components';

export const StyledCheckboxRenderer = styled.div`
  display: flex;
  flex-direction: row;
  width: calc(100%);
`;

export const StyledHighVolumeGridContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
`;

export const StyledHighVolumeGridElement = styled.div`
  overflow: hidden;
  flex-grow: 1;
`;

export const StyledHighVolumeGridDimension = styled.div`
  height: 100%;
  width: 100%;
`;
